module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flowLog-container"
  }, _vm._l((_vm.logData), function(item) {
    return _c('div', {
      staticClass: "flowLog-item"
    }, [_c('div', {
      staticClass: "fl w-190 ovf-hd",
      attrs: {
        "title": item.content
      }
    }, [_vm._v(_vm._s(item.content))]), _vm._v(" "), _c('div', {
      staticClass: "fl m-l-20"
    }, [_vm._v(_vm._s(_vm._f("toTime")(item.create_time)))])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4192aad0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Flow/instance/log.vue
// module id = 1838
// module chunks = 2